<template>
  <button
    :class="[
      'base-button',
      isCancel ? 'cancel' : 'principal',
      isDisabled ? 'disabled' : '',
    ]"
    :disabled="isDisabled"
  >
    {{ buttonLabel }}
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "StandardButton",
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isCancel: {
      type: Boolean,
      default: false,
    },
    buttonLabel: {
      type: String,
      default: "Botón",
    },
  },
});
</script>

<style scoped lang="scss">
@import "src/generalStyle/controls/standardButton";
</style>
